"use strict";
export function calculateGasMargin(value) {
  return value.mul(120).div(100);
}
